import {
    useCallback,
    useMemo,
} from 'react'
import {
    GridFilterInputValueProps,
} from '@mui/x-data-grid-pro'

import Switch from 'app/shared-components/Switch'
import useStyles from './BooleanSwitchFilterInput.styles'

function BooleanSwitchFilterInput({
    item,
    applyValue,
}: Readonly<GridFilterInputValueProps>) {
    const {
        classes,
    } = useStyles()
    const value = useMemo(() => {
        return item.value || false
    }, [item])

    const onChange = useCallback((turnedOn: boolean) => {
        applyValue({
            ...item,
            value: turnedOn === true ? true : null,
        })
    }, [
        applyValue,
        item,
    ])

    return (
        <div className={classes.container}>
            <Switch
                onChange={onChange}
                value={value}
            />
        </div>
    )
}

export default BooleanSwitchFilterInput
